import { MaskedButton } from "./modules/mask-button.js";
import { MobileMenu } from "./modules/mobile-menu.js";
import { queryAll, query, setProps } from "./utils.js";
import { GridWidthFix } from "./modules/grid-width-fix.js";
import scrollRevealInit from "./modules/scroll-reveal.js";

// const BlockEditorGridWidthFix = require("./modules/block-editor-grid-width-fix.js");
// new BlockEditorGridWidthFix();
new MobileMenu();
new GridWidthFix();

document.addEventListener("readystatechange", (event) => {
	if (document.readyState === "complete") {
		const body = query("body");
		setProps(body, { "--internal-url": window.location.host });

		const maskBtns = [...queryAll(".mask-btn")];

		maskBtns.forEach((el) => {
			if (!el.instance) el.instance = new MaskedButton(el);
		});

		const stickyElm = query("header");

		const observer = new IntersectionObserver(
			([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
			{ threshold: [1] }
		);

		observer.observe(stickyElm);
	}
});

(() =>
	document.addEventListener("DOMContentLoaded", () => {
		scrollRevealInit();
		// Search and delete all elements that match <div class="sub-menu-heading">_</div>
        const elements = document.querySelectorAll('.sub-menu-heading');
        elements.forEach(function(element) {
			
            if (element.innerHTML.trim() === "_") {
                element.parentNode.removeChild(element);
            }
        });
	}))();
class LazyImage extends HTMLImageElement {
	constructor() {
		super();
	}

	connectedCallback() {}
}

customElements.define("block-lazy-image", LazyImage, {
	extends: "img",
});
window.addEventListener('load', function () {
	const cookieBanner = document.querySelector('.cky-consent-container');
	const cookieOverlay = document.querySelector('.cky-overlay');
	const cookieModal = document.querySelector('.cky-modal');
	const revisitBtn = document.querySelector('.cky-btn-revisit-wrapper');
  
	if (cookieBanner) {
	  cookieBanner.style.opacity = "1";
	  cookieBanner.style.position = "fixed";
	  cookieBanner.style.zIndex = "9999";
	  cookieBanner.style.pointerEvents = "auto";
	}
  
	if (cookieOverlay) {
	  cookieOverlay.style.opacity = "1";
	  cookieOverlay.style.position = "fixed";
	  cookieOverlay.style.zIndex = "9998";
	  cookieOverlay.style.pointerEvents = "auto";
	}
  
	if (cookieModal) {
	  cookieModal.style.opacity = "1";
	  cookieModal.style.position = "fixed";
	  cookieModal.style.zIndex = "9999";
	  cookieModal.style.pointerEvents = "auto";
	}
  
	if (revisitBtn) {
	  revisitBtn.style.opacity = "1";
	  revisitBtn.style.position = "fixed";
	  revisitBtn.style.zIndex = "9999";
	  revisitBtn.style.pointerEvents = "auto";
	}
  });